/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Fragment } from 'react'
import { cf2imgix } from '../../utils/cf2imgix'

export const JUDGES_CONFIG = [
  {
    name: 'Tomi Adebayo',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/5efqeho00kgrQIfpAY1rZt/8ddc1b0002289b79cc732c969d881839/Tomi-Adebayo-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          With more than a decade in the tech industry, Tomi - better known as
          GadgetsBoy - was a Software Engineer before becoming one of the UK's
          leading tech and gadget experts.
        </p>
        <p>
          Tomi can be found online using his experience, expertise and
          understanding to help consumers make an informed buying decision
          through his reviews.
        </p>
      </Fragment>
    ),
    title: 'Tech Influencer',
    socialMediaTag: '@GadgetsBoy',
    socialMediaHref: 'https://twitter.com/GadgetsBoy'
  },
  {
    name: 'Jonathan Morris',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/3deQSWI0VMMWtTl8uPAE1y/34923255e414c41f4d049ca64420379c/Jonathan-Morris-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Jonathan has a long history in the mobile industry, starting out
          writing for a trade newspaper in the 1990s and going on to be editor
          of What Mobile, the UK's leading mobile magazine at the time.
        </p>
        <p>
          He has written for numerous magazines, newspapers and websites,
          consulted on handset design, and now works on his own site. He has a
          timeless passion for all technology, plus a keen interest in mobile
          photography.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist',
    socialMediaTag: '@jmcomms',
    socialMediaHref: 'https://twitter.com/jmcomms'
  },
  {
    name: 'Chris Hall',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/8U074wYK73wdWkc7nOOww/02c16de25acf0b22338dfef5093060aa/chris-hall-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Chris has been a tech journalist for over 14 years and is currently
          the Editor at Pocket-lint.
        </p>
        <p>
          He has contributed to the likes of Amazon.co.uk and ComputerActive,
          made appearances on television for the BBC and Sky, along with wider
          radio contributions and was a judge on The Apprentice.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist',
    socialMediaTag: '@christhall',
    socialMediaHref: 'https://twitter.com/christhall'
  },
  {
    name: 'Carly Page',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/6ibgCvlK05iI0PvoLd51fo/e3ae046454850b72f723adcf8655e52e/Carly-Page-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Carly Page is a freelance technology journalist, editor and copywriter
          with more than a decade of experience in the industry.
        </p>
        <p>
          She served as Editor of tech outlet The INQUIRER from 2012 until 2019.
          After this, she entered the world of freelance journalism and has
          since written for a range of publications including Forbes, the Metro,
          TechRadar, TES, Wired and TechCrunch.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist',
    socialMediaTag: '@carlypage_',
    socialMediaHref: 'https://twitter.com/CarlyPage_'
  },
  {
    name: 'Ortis Deley',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/1LYSUhpnA3n8s7nhmZ3vtq/75abb6c7da16116bf4ead8edb5b79619/Ortis-Deley-min.JPEG'
    ),
    bio: (
      <Fragment>
        <p>
          Ortis Deley has been one the hosts of Channel 5’s The Gadget Show
          since 2009.
        </p>
        <p>
          Ortis’s affinity for science and technology began when he was a child
          who was very much into sci-fi and comic books. His comic collection is
          around 8,000 units! He is a bonafide geek.
        </p>
        <p>
          He supports a handful of charities and is a patron of First Touch.
        </p>
      </Fragment>
    ),
    title: 'Tech Broadcaster',
    socialMediaTag: '@OrtisDeley',
    socialMediaHref: 'https://twitter.com/OrtisDeley'
  },
  {
    name: 'Ian White',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/4Uaax7twfnf9mA7mGkH2tz/b20da3c8f265766121cbe3a3349d2e8d/Ian-White-min.jpeg'
    ),
    bio: (
      <p>
        Ian White is founder and editorial manager of UK mobile telecoms channel
        B2B publication, Mobile News, which covers news and analysis in the
        distribution, manufacturing, and retail sectors of the channel
      </p>
    ),
    title: 'Tech Journalist'
  },
  {
    name: 'Nick Baker',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/5Hh1GAr6BQ2eXBaGOr6kO9/6fd442e35a63b6357108ab5c22a989a8/Nick-Baker-min.jpg'
    ),
    title: 'Senior Editor',
    bio: (
      <Fragment>
        <p>
          Nick has been in Uswitch’s telecoms editorial team for five years,
          covering all topics across broadband, TV, mobiles and gaming.
        </p>
        <p>
          He is also Uswitch’s resident video content producer, directing video
          explainers across Uswitch’s various industries to help customers make
          more informed choices with their services.
        </p>
      </Fragment>
    )
  },
  {
    name: 'Chris Barraclough',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/4ERfPaTSSWm4T2Dv4mO9xM/195281ab3f44227a896f83248715ff27/Chris-Barraclough-min.JPG'
    ),
    bio: (
      <Fragment>
        <p>
          Chris Barraclough is the creator of breakthrough YouTube channel Tech
          Spurt, which hit 900k subscribers and counting in 2022.
        </p>
        <p>
          Previously he was Editor-In-Chief at Recombu, as well as Devices
          Editor of Mobile Choice magazine.
        </p>
      </Fragment>
    ),
    title: 'Content Creator',
    socialMediaTag: '@TechSpurtVideo',
    socialMediaHref: 'https://twitter.com/techspurtvideo'
  },
  {
    name: 'Joe Svetlik',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/ttdTMNP4oVUnlB481svO2/05346a9a6b552ebd402c99a85a7aebd0/Joe-Svetlik-min.jpeg'
    ),
    bio: (
      <Fragment>
        <p>
          Joe has been writing about tech since 2004, so he remembers flip
          phones the first time round. He has worked for T3 magazine, Stuff, The
          Sunday Times Travel Magazine, Men's Health, GQ, The Mirror, Trusted
          Reviews, TechRadar and many more.
        </p>
        <p>
          His specialities include all things mobile, wireless headphones and
          plenty else he can’t justify buying.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist'
  },
  {
    name: 'Richard Priday',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/cqwAYVzFxPfW2aZHtVia5/4c89194c1072c695e733e1527f5c9fd1/Richard-Priday-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Richard is a Tom's Guide senior writer based in London, covering news,
          reviews and how-tos for phones, tablets, gaming, and whatever else
          people need advice on. Following on from his MA in Magazine Journalism
          at the University of Sheffield, he's also written for WIRED U.K., The
          Register and Creative Bloq.
        </p>
        <p>
          When not at work, he's likely thinking about how to brew the perfect
          cup of specialty coffee.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist'
  },
  {
    name: 'Dave Snelling',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/2JTI6G94HPut8cc1Z8i93r/9de6e299859a803917fc10da8def0562/Dave-Snelling-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Dave has worked on Fleet Street for over 25 years and enjoyed numerous
          roles across the industry.
        </p>
        <p>
          The last decade as Technology Editor has been the highlight and he
          continues to have an unwavering passion for reporting on all of the
          very latest news from the biggest names in the sector.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist'
  },
  {
    name: 'Mike Moore',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/4u0teekwp3uOMR6184oNou/1540e9bc32eb540b5fa9e15e5438c1cb/Mike-Moore-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Mike Moore is Deputy Editor at TechRadar Pro, the main outlet of
          Future's B2B Tech Pro division. He has worked as a B2B and B2C tech
          journalist for nearly a decade, including at one of the UK's leading
          national newspapers.
        </p>
        <p>
          When he's not keeping track of all the latest enterprise and workplace
          trends, can most likely be found watching, following or taking part in
          some kind of sport.
        </p>
      </Fragment>
    ),
    title: 'Tech Journalist'
  },
  {
    name: 'Jamie Harris',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/OYdff6JH4sD7JbwLlsQlt/1bdb9f876cd39b41ae8d78234c725372/Jamie-Harris-min.jpg'
    ),
    bio: (
      <Fragment>
        <p>
          Jamie has been reporting on the tech scene for more than decade, with
          bylines in almost all UK national and regional news outlets during his
          time at PA.
        </p>
        <p>He is currently Senior Tech and Science Reporter for The Sun.</p>
      </Fragment>
    ),
    title: 'Tech Reporter',
    socialMediaTag: '@JamieHarrisTech',
    socialMediaHref: 'https://twitter.com/JamieHarrisTech'
  },
  {
    name: 'Martyn Landi',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/6cYWQ7aCTwCbyOZDJj1pa2/9b16b26d1a882a1aac963921f248473a/Martyn-Landi-min.jpg'
    ),
    title: 'Tech Journalist',
    bio: (
      <p>
        Martyn Landi is the Technology Correspondent for PA Media, the UK's
        national news agency. He has been writing about technology for over ten
        years, and can be found posting on X @MartynLandi.
      </p>
    )
  },
  {
    name: 'Jon Devo',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/4phb9zGwyQ4ZQHO9V7b1RK/af84520b6db71bee060790db9ffe0981/Jon-Devo-min.jpg'
    ),
    title: 'Tech Journalist',
    bio: (
      <p>
        Jon Devo is a professional photographer and videographer of 20 years. He
        became a presenter and journalist after studying Journalism and
        Psychology at City University London in 2009. Jon founded the Devoted
        Creatives photo and video studio and hosts two podcasts for Spotify;
        Shot & Chaser and The Devoted Creatives Podcast. He also has a monthly
        column in Digital Camera Magazine, called Scanning Ahead. Jon regularly
        contributes to a number of leading publications including WIRED, and T3
        and Digital Camera Magazine as a guest writer.
      </p>
    )
  },
  {
    name: 'Hannah Cowton',
    imgUrl: cf2imgix(
      '//images.ctfassets.net/n36b8lzdmgnp/2DB7M1vkpljnfvvS7mm9vt/256e458db2583a6c6575847f132a7f7f/Hannah-Cowton-min.jpg'
    ),
    title: 'Tech Journalist',
    bio: (
      <Fragment>
        <p>
          As a Senior Entertainment Writer at Tech Advisor, Hannah Cowton is an
          expert in all things streaming. She's reviewed a whole range of
          technology products and has a keen eye for spotting a good mobile or
          broadband deal.
        </p>
        <p>
          Outside of her main role, she's written freelance pieces for Metro,
          Polygon and Den of Geek, and she's also a Women Techmakers Ambassador
          for Google.
        </p>
      </Fragment>
    )
  }
]
